export default "__VITE_ASSET__CVkbBdI1__"